<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="table">
          <table class="table">
            <thead class=" text-primary">
              <tr>
                <th>
                  Name
                </th>
                <th>
                  <router-link v-if="$dataManager.getters.permissions.Live.includes('create')" :to="{name:'Live.Create'}">
                    <div class="btn btn-xs btn-success btn-round pull-right">Create</div>
                  </router-link>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in live" :key="i">
                <td v-text="item.name" />
                <td>
                  <router-link
                    v-if="$dataManager.getters.permissions.Live.includes('update')"
                    :to="{name:'Live.Update',params:{id:item.id}}"
                  >
                    <div class="btn btn-xs btn-primary  pull-right">Update</div>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LiveList',
  data: function() {
    return {
      live: []
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData: function() {
      this.$store.commit('OPEN_LOADING')

      this.$store.dispatch('getList', { type: 'LiveShow', action: 'list' }).then((res) => {
        if (!res.errorCode) {
          this.$store.commit('CLOSE_LOADING')

          this.live = res.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
